// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WixStudioNotification_wrapper__lImB8","text":"WixStudioNotification_text__Lb_Sn"};